/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_RecencyInputs */

const en_svchip_recency = /** @type {(inputs: Svchip_RecencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recency`)
};

const ar_svchip_recency = /** @type {(inputs: Svchip_RecencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأحدثية`)
};

const bn_svchip_recency = /** @type {(inputs: Svchip_RecencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রিসেন্সি`)
};

const de_svchip_recency = /** @type {(inputs: Svchip_RecencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualität`)
};

const es_svchip_recency = /** @type {(inputs: Svchip_RecencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualidad`)
};

const fr_svchip_recency = /** @type {(inputs: Svchip_RecencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récence`)
};

const pt_svchip_recency = /** @type {(inputs: Svchip_RecencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo para Tempo Recente`)
};

const zh_svchip_recency = /** @type {(inputs: Svchip_RecencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新近度`)
};

const tr_svchip_recency = /** @type {(inputs: Svchip_RecencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yenilik`)
};

const ru_svchip_recency = /** @type {(inputs: Svchip_RecencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Давность`)
};

const pl_svchip_recency = /** @type {(inputs: Svchip_RecencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualność`)
};

/**
* | output |
* | --- |
* | "Recency" |
*
* @param {Svchip_RecencyInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_recency = /** @type {((inputs?: Svchip_RecencyInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_RecencyInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_recency(inputs)
	if (locale === "bn") return bn_svchip_recency(inputs)
	if (locale === "de") return de_svchip_recency(inputs)
	if (locale === "es") return es_svchip_recency(inputs)
	if (locale === "fr") return fr_svchip_recency(inputs)
	if (locale === "pt") return pt_svchip_recency(inputs)
	if (locale === "zh") return zh_svchip_recency(inputs)
	if (locale === "tr") return tr_svchip_recency(inputs)
	if (locale === "ru") return ru_svchip_recency(inputs)
	if (locale === "pl") return pl_svchip_recency(inputs)
	return en_svchip_recency(inputs)
});